import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { SurveysCont, SurveysTableCont } from './Surveys.styles';
import CreateSurveyModal from '../../components/CreateSurveyModal/CreateSurveyModal';
import Table from '../../components/Table/Table';
import { useSurveyTable } from '../../hooks/useSurveyTable';
import { IPagingInfo, ISurveyItem, ISurveyResp } from '../../services/surveys';

const metadataInitial = {
  pageNo: null,
  itemsPerPage: null,
  totalPageCount: null,
  totalItemsCount: null,
  memberCount: null,
  subordinateCount: null,
  superordinateCount: null,
  leaderCount: null,
};

const Surveys: FC = () => {
  const [active, setActive] = useState(false);
  const { search } = useLocation();
  const [loading, setLoading] = useState(false);
  const [metadata, setMetadata] = useState<IPagingInfo>(metadataInitial);
  const activeView = 'surveys';
  const [surveyList, setSurveyList] = useState<ISurveyItem[]>([]);
  const { downloadSurveyList, applyFilters } = useSurveyTable();

  const setSurveyData = (list: ISurveyResp) => {
    const { items, pagingInfo } = list;
    setSurveyList(items);
    setMetadata(pagingInfo);
    setLoading(false);
  };

  const updateSurveysList = useCallback(async () => {
    try {
      setLoading(true);
      const list = await downloadSurveyList();
      setSurveyData(list);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [search]);

  const navigateInsideView = useMemo(() => {
    switch (activeView) {
      case 'surveys':
        return (
          <Table
            metadata={metadata}
            applyFilters={applyFilters}
            listArray={surveyList}
            loading={loading}
            openCreateModal={() => setActive(true)}
          />
        );
      default:
        return (
          <Table
            metadata={metadata}
            applyFilters={applyFilters}
            listArray={surveyList}
            loading={loading}
            openCreateModal={() => setActive(true)}
          />
        );
    }
  }, [activeView, metadata, surveyList, applyFilters, loading]);

  useEffect(() => {
    (async () => await updateSurveysList())();
  }, [search]);

  return (
    <SurveysCont>
      <CreateSurveyModal
        active={active}
        closeModal={() => setActive(!active)}
        refreshList={updateSurveysList}
      />
      <SurveysTableCont>{navigateInsideView}</SurveysTableCont>
    </SurveysCont>
  );
};
export default Surveys;
